import { controlList, storagePage, reqSubStowage, filterForm } from '../storage'
import { SimpleOption } from '../../../components/Option'
import Dropdown from '../../../components/Dropdown'
import { Option as OptionType } from '../../../config/types/component'
import { IterateOptions, FormControl } from '../../../components/FormUtilities'
import useStorage from '../../../hooks/useStorage'
import useGet from '../../../hooks/useGet'
import Pdf from './Pdf'
import Product from '../../../models/Product'
import Stowage from '../../../models/Stowage'
import MinimalStowage from '../../../models/MinimalStowage'
import loadHead from '../utilities/loadHead'
import moment from 'moment'
import { viewPrint } from '../../../sections/ModalPrint'
import DatePicker from '../../../components/Datepicker'
import { Keys } from '../constants'
import { useRender, render } from 'redity'
import {
    FlexBox,
    FlexLeft,
    FlexRight,
    SectionFiltersGrid
} from '../../../components/UtilsResponsive/UtilsResponsive.style'
import { setCompanySelected } from '../../../utilities/controlStorage'
import { buildPath } from '../../../sections/ModalPrint/utils'
import OptionExcel from './Export/OptionExcel'
import DropContent from '../../../components/DropContent'
import SelectTouch from '../../../components/SelectTouch'
import { getProductManufacturerCode } from '../../../utilities/productDisplay'

function Company() {
    const { props } = controlList.useFilter('company_id')
    const { companiesFromSession } = useStorage()
    async function handleChange(option: OptionType) {
        const company = companiesFromSession.find(
            comp => comp.id === parseInt(option.value)
        )
        setCompanySelected(company)
        storagePage.currency = company.local_currency
        controlList.filter.deleteFilter('product_id')
        props.onChange(option)
        await loadHead()
        await props.onChange(option)
    }

    return (
        <Dropdown
            {...props}
            label="Compañía"
            clear={false}
            onChange={handleChange}
            showLabel={false}
        >
            <IterateOptions
                data={companiesFromSession.map(company => ({
                    name: company.name,
                    image_url: company.country.image_url,
                    id: company.id,
                    disabled: !company.is_enabled
                }))}
                label="name"
                image="image_url"
                strikeOut="disabled"
            />
        </Dropdown>
    )
}

function ProductSelect() {
    const companyId = controlList.filter.getParam('company_id')
    return (
        <ProductSelectInner
            key={companyId ?? 'no-company'}
            companyId={companyId}
        />
    )
}

function ProductSelectInner({ companyId }: { companyId?: string }) {
    const productsPath = companyId
        ? buildPath('/v5.6/apis/products', [
              ['company_id', companyId],
              ['limit', '10']
          ])
        : '/v5.6/apis/products?limit=10'
    const { data, props } = controlList.useFilter<Product>(
        'product_id',
        productsPath
    )

    async function handleChange(option: OptionType) {
        const product = data.find(item => item.id === parseInt(option.value))
        if (!product) return
        const manufacturerCode = getProductManufacturerCode(product as any)
        props.onChange(option)
        controlList.filter.setOption('product_id', {
            value: product.id.toString(),
            label: manufacturerCode,
            label2: manufacturerCode,
            label3: product.name
        } as any)
        await controlList.load()
        controlList.render()
        await loadHead()
        render(Keys.HEADER)
    }
    return (
        <Dropdown
            label="Producto de Kardex"
            {...props}
            onChange={handleChange}
            clear={false}
            fullWidth={true}
            className="justify-start"
        >
            <IterateOptions
                data={(data || []).map(product => ({
                    ...product,
                    manufacturer_code: getProductManufacturerCode(
                        product as any
                    )
                }))}
                label="name"
                label2="manufacturer_code"
            />
        </Dropdown>
    )
}

function StartDateField() {
    const { props } = filterForm.useDate('start_date')

    function handleChange(option: OptionType) {
        props.onChange(option)
    }

    return (
        <FormControl label="Fecha inicio">
            <DatePicker
                {...props}
                infoZ=""
                onChange={handleChange}
                placeholder="Fecha inicio"
            />
        </FormControl>
    )
}

function EndDateField() {
    const { props } = filterForm.useDate('end_date')

    function handleChange(option: OptionType) {
        props.onChange(option)
    }

    return (
        <FormControl label="Fecha fin" className="mt-1">
            <DatePicker
                {...props}
                infoZ=""
                onChange={handleChange}
                placeholder="Fecha fin"
                maxDate={moment().toISOString(true)}
            />
        </FormControl>
    )
}

function StowageField() {
    useRender(Keys.FILTER_FORM)
    const { data, props } = filterForm.useSelect<Stowage>('stowage_id', () => {
        const company_id = controlList.filter.params.company_id
        return `/v5.6/apis/stowages?company_id=${company_id}&require_all_substowages=false&require_stowage_value=false`
    })

    function handleChange(option: OptionType) {
        props.onChange(option)

        filterForm.setValue('minimal_stowage_id', null)

        reqSubStowage.setParam('stowage_id', option.value)
        reqSubStowage.load()
    }

    return (
        <FormControl label="Bodega" className="mt-1">
            <SelectTouch
                {...props}
                onChange={handleChange}
                placeholder="Seleccionar bodega"
            >
                <IterateOptions data={data || []} label="name" />
            </SelectTouch>
        </FormControl>
    )
}

function SubStowageField() {
    const { props } = filterForm.useSelect<MinimalStowage>('minimal_stowage_id')
    const { data, props: prosSearch } = useGet<MinimalStowageResponse[]>(
        reqSubStowage.observer(
            `/v5.6/apis/stowages/:stowage_id/substowages`,
            true
        ),
        []
    )

    let disabled = true
    if (filterForm.store().stowage_id) {
        const arrayStowage = [
            'Bodega Pedidos',
            'Bodega Remisionada',
            'Bodega Garantía Proveedor'
        ]
        disabled = !arrayStowage.includes(filterForm.store().stowage_id.label)
    }

    function handleChange(option: OptionType) {
        props.onChange(option)
    }

    return (
        <FormControl label="Sub Bodega" className="mt-1">
            <SelectTouch
                {...props}
                {...prosSearch}
                disabled={disabled}
                placeholder="Seleccionar sub bodega"
                onChange={handleChange}
            >
                <IterateOptions
                    data={data.result || []}
                    label="substowage_name"
                />
            </SelectTouch>
        </FormControl>
    )
}

interface MinimalStowageResponse extends MinimalStowage {
    substowage_name: string
}

function FiltersDropContent() {
    useRender(Keys.FILTER_FORM)
    const { props } = controlList.useForm(
        filterForm,
        form => ({
            start_date: form.start_date
                ? moment(form.start_date).format('DD/MM/YYYY')
                : null,
            end_date: form.end_date
                ? moment(form.end_date).format('DD/MM/YYYY')
                : null
        }),
        form => ({
            start_date: form.start_date
                ? moment(form.start_date).format('YYYY-MM-DD')
                : null,
            end_date: form.end_date
                ? moment(form.end_date).format('YYYY-MM-DD')
                : null
        })
    )

    async function handleApply() {
        await props.onApply()

        const formData = filterForm.store()

        if (formData.start_date) {
            const startDate = moment(formData.start_date).format('YYYY-MM-DD')
            controlList.filter.setParams('start_date', startDate)
        }

        if (formData.end_date) {
            const endDate = moment(formData.end_date).format('YYYY-MM-DD')
            controlList.filter.setParams('end_date', endDate)
        }

        if (formData.stowage_id) {
            controlList.filter.setParams(
                'stowage_id',
                formData.stowage_id.value
            )
        } else {
            controlList.filter.deleteFilter('stowage_id')
        }

        if (formData.minimal_stowage_id) {
            controlList.filter.setParams(
                'minimal_stowage_id',
                formData.minimal_stowage_id.value
            )
        } else {
            controlList.filter.deleteFilter('minimal_stowage_id')
        }

        render(Keys.EXPORT)
        render(Keys.FILTER_FORM)

        if (controlList.filter.params.product_id) {
            await controlList.load()
            controlList.render()
            await loadHead()
            render(Keys.HEADER)
        }
    }

    return (
        <DropContent {...props} onApply={handleApply} label="Filtros">
            <StartDateField />
            <EndDateField />
            <StowageField />
            <SubStowageField />
        </DropContent>
    )
}

function Export() {
    useRender(Keys.EXPORT)
    function handleClick() {
        const path = buildPath('/v5.6/apis/kardex', [
            ['company_id', controlList.filter.getParam('company_id')],
            ['product_id', controlList.filter.getParam('product_id')],
            ['start_date', controlList.filter.getParam('start_date')],
            ['end_date', controlList.filter.getParam('end_date')],
            ['stowage_id', controlList.filter.getParam('stowage_id')],
            [
                'minimal_stowage_id',
                controlList.filter.getParam('minimal_stowage_id')
            ]
        ])
        viewPrint(path, () => ({
            Component: Pdf
        }))
    }

    return <SimpleOption onClick={handleClick}>Exportar en .pdf</SimpleOption>
}

export default function Filters() {
    return (
        <SectionFiltersGrid>
            <ProductSelect />
            <FlexBox>
                <FlexLeft className="space-x-1">
                    <Company />
                    <FiltersDropContent />
                </FlexLeft>
                <FlexRight>
                    <Dropdown label="Exportar" icon="download" clear={false}>
                        {/* <Rules cu="CU130"> */}
                        <OptionExcel />
                        <Export />
                        {/* </Rules> */}
                    </Dropdown>
                </FlexRight>
            </FlexBox>
        </SectionFiltersGrid>
    )
}
